import Checkbox, {CheckboxGroup} from './Checkbox';
import './Checkbox.scss';
export {CheckboxGroup};
export default Checkbox;
